namespace TabAurous.Inventory {
    export interface ConvertToWIPForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        DepartmentId: Serenity.LookupEditor;
        ProcessId: Serenity.LookupEditor;
        BagNo: Serenity.LookupEditor;
        SubBagNo: Serenity.IntegerEditor;
        UserId: Serenity.LookupEditor;
        Line_No: Serenity.StringEditor;
        TermsId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        EmployeeId: Serenity.IntegerEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: ConvertToWIPItemsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class ConvertToWIPForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.ConvertToWIP';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ConvertToWIPForm.init)  {
                ConvertToWIPForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.LookupEditor;
                var w5 = s.DecimalEditor;
                var w6 = s.ImageUploadEditor;
                var w7 = ConvertToWIPItemsEditor;

                Q.initFormType(ConvertToWIPForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'DepartmentId', w4,
                    'ProcessId', w4,
                    'BagNo', w4,
                    'SubBagNo', w3,
                    'UserId', w4,
                    'Line_No', w2,
                    'TermsId', w3,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'CurrencyId', w4,
                    'ExchRate', w5,
                    'EmployeeId', w3,
                    'ProductItemImage', w6,
                    'ItemDetails', w7,
                    'FinancialYearId', w3,
                    'Pieces', w3,
                    'Weight', w5,
                    'NetWeight', w5,
                    'NetAmount', w5,
                    'Discount', w5,
                    'AdditionalCharges', w5,
                    'GrossAmount', w5,
                    'Remark', w2,
                    'ShipmentId', w3,
                    'ShipAddressId', w3,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
